var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfternoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Afternoon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4200",
    x: 0.5,
    y: 0.5,
    width: 27.3625,
    height: 20.78,
    rx: 5.5,
    fill: "#F5F5F5",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M15.8898 13.154H12.1068L11.4568 15H9.90977L13.1468 5.952H14.8628L18.0998 15H16.5398L15.8898 13.154ZM15.4738 11.945L14.0048 7.746L12.5228 11.945H15.4738Z",
    fill: "#233849"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfternoon);
export default __webpack_public_path__ + "static/media/Afternoon.dc8e10d40b67ac906af2b0a2de82c12e.svg";
export { ForwardRef as ReactComponent };